import React, { Children } from 'react';
import { HeartIcon, BanknoteIcon, SparklesIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const painPoints = [{
  id: 1,
  icon: HeartIcon,
  title: 'Libérate del estrés',
  description: 'Encuentra en el tricotín una actividad creativa que te relaja y te llena de satisfacción.'
}, {
  id: 2,
  icon: BanknoteIcon,
  title: 'Genera ingresos extra',
  description: 'Convierte tu creatividad en una fuente de ingresos real, vendiendo piezas únicas y personalizadas.'
}, {
  id: 3,
  icon: SparklesIcon,
  title: 'Fácil de aprender',
  description: 'No necesitas experiencia previa. Con nuestro método, estarás creando piezas increíbles desde el primer día.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function PainPointsSection() {
  return <section className="py-20 bg-transparent" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="text-center mb-16" data-id="element-145">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-dark" data-id="element-146">
            ¿Sientes que es momento de crear algo propio?
          </motion.h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-147">
          {painPoints.map(point => <motion.div key={point.id} variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-gray-100 transition-all duration-300 hover:-translate-y-2 flex flex-col items-center text-center group" data-id="element-148">
              <div className="w-16 h-16 rounded-full bg-mint/10 flex items-center justify-center mb-6 group-hover:bg-mint/20 transition-colors" data-id="element-149">
                <point.icon className="w-8 h-8 text-mint" data-id="element-150" />
              </div>
              <h3 className="text-xl font-bold text-dark mb-4" data-id="element-151">
                {point.title}
              </h3>
              <p className="text-muted leading-relaxed" data-id="element-152">{point.description}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}